import type { TravelMode } from 'tripPlanner/api/routes/getRouteInfo'
import { roundLatLng } from './utils'

export const routeDirectionsQueryKey = (
  origin?: { lat: number, lng: number },
  destination?: { lat: number, lng: number },
  travelMode?: TravelMode,

) => ['routeDirections', roundLatLng(origin), roundLatLng(destination), travelMode] as const
